import { NextPageContextEnhanced } from "../../types/page";
import EssentialData from "../classes/EssentialData.class";

export  function applyEssentialData(context: NextPageContextEnhanced) {
  context.essentialData = EssentialData.getInstance(context);
  context.essentialData.setAllEssentialData(context.req.customContext.allEssentialData);
  context.essentialData.setAllTranslations(context.req.customContext.translationsFiles);
}
